import { Head } from "zudoku/components";

"use client";

export default function SwaggerM2mPage() {
    return (
        <section style={{ padding: "1rem 0" }}>
            <Head>
                <title>Swagger Widget</title>
            </Head>
            <iframe
                src="/swagger/swagger-webclient.html"
                style={{
                    width: "100%",
                    height: "100vh",
                    border: "none"
                }}
            />
        </section>
    );
}
